import React from "react";
function Preloader() {
  return (
    <div className="preloader">
      <div className="ship"></div>
      <div className="waves"></div>
    </div>
  );
}
export default Preloader;
